export const pageNavigation = {
  methods: {
    account() {
      localStorage.removeItem("userInfo");
      localStorage.removeItem("token");
      window.location = "https://home.trebel.io";
    },
    shop() {
      this.$store.dispatch("payment/paymentData", {});
      this.$router.push({ path: "/" }).catch(() => {});
    },
    openNavBar() {
      this.$refs.overlayNavBar.style.width = "100%";
    },
    closeNav() {
      this.$refs.overlayNavBar.style.width = "0%";
    },
    closeAccount() {
      this.$router.push({ path: "close-account" }).catch(() => {});
    },
    deleteAccount() {
      this.$router.push({ query: { q: "close" } }).catch(() => {});
    }
  }
};

export default pageNavigation;
